export const DEFAULT_BACKGROUND_COLOR = '#fff';
export const DEFAULT_INPUT_PLACEHOLDER = 'Enter your icon description here';
